const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/login/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { pickString } from "@/lib/search-params";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
interface LoginSearch {
  mode?: "signin" | "signup";
  redirect?: string;
}
function pickLoginMode(value: unknown): LoginSearch["mode"] {
  return value === "signup" || value === "signin" ? value : undefined;
}
export const Route = createFileRoute("/_app/login/")({
  validateSearch: (raw: Record<string, unknown>): LoginSearch => ({
    mode: pickLoginMode(raw.mode),
    redirect: pickString(raw.redirect)
  }),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    return {
      meta: buildPrivatePageMetaTags(tMeta("signIn"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});